import { Instance, types } from 'mobx-state-tree'

import { JsonMap, UserTraits } from '@segment/analytics-react-native'

import { EnvironmentStages } from '../environment/environment.store'
import { withRootStore } from '../extensions'
import { segmentClient } from './segment'
import { toAnalyticsIdentity } from './analytics-identity'
import { firebaseAnalytics } from '@/modules/firebase'
import { Platform } from 'react-native'
/**
 * A SessionEventAnalyticsModel model.
 */

// New default: don't actually send in simulator, emulator, dev builds
// If needed override with 'true' here (while testing new events)
const turnOn = !__DEV__

export const EventAnalyticsStore = types
  .model('EventAnalyticsStore')
  .props({
    event: types.maybe(types.string)
  })
  .extend(withRootStore)
  .actions((self) => ({
    //props type -> JsonMap
    setEvent(event: string, props?: JsonMap) {
      const user = self.rootStore.session.user
      let eventProps = props
      if (props && user?.auth0Id) {
        // Only translate the current account's ID; another user's ID may be event data.
        eventProps = {
          ...props,
          ...(props.userId === user._id && { userId: user.auth0Id }),
          ...(props.user_id === user._id && { user_id: user.auth0Id })
        }
      }
      turnOn && segmentClient?.track(event, eventProps)
    },
    getUserIdentify() {
      const anonymousId = segmentClient?.userInfo?.get().anonymousId
      return anonymousId
    },
    getSegmentUserID() {
      const segmentUserID = segmentClient?.userInfo?.get().userId
      return segmentUserID
    },
    isSkillLevelAvailableInTraits() {
      const traits = segmentClient?.userInfo?.get().traits
      if (traits?.skill_level) {
        return true
      }
      return false
    },
    //props type -> UserTraits
    setUserIdentify(userid: string, props?: UserTraits) {
      const sessionUser = self.rootStore.session.user
      if (sessionUser && userid === sessionUser._id) {
        const identity = toAnalyticsIdentity(sessionUser)
        userid = identity.userId
        props = { ...props, ...identity.traits }
      }
      turnOn && segmentClient?.identify(userid, props)
      //TODO: not working on web
      if (Platform.OS !== 'web') {
        firebaseAnalytics().setUserId(userid)
      }
    }
  }))
  .actions((self) => ({
    async setAlias(userId: string) {
      turnOn && (await segmentClient?.alias(userId))

      //TODO: not working on web
      if (Platform.OS !== 'web') {
        await firebaseAnalytics().setUserId(userId)
        await firebaseAnalytics().setUserProperties({ userId })
      }
    },
    async setAnalyticsStage(stage: EnvironmentStages) {
      // try {
      //   if (stage === EnvironmentStages.prod) {
      //     segmentClient = createClient({
      //       writeKey: EnvironmentStages.prod,
      //       autoAddSegmentDestination: true,
      //       trackAppLifecycleEvents: true,
      //       trackDeepLinks: true,
      //     })
      //   } else {
      //     segmentClient = createClient({
      //       writeKey: EnvironmentStages.dev,
      //       autoAddSegmentDestination: true,
      //       trackAppLifecycleEvents: true,
      //       trackDeepLinks: true,
      //     })
      //   }
      //   segmentClient.add({ plugin: new MixpanelPlugin() })
      // } catch (error) {
      //   console.warn('session-analytics setAnalyticsStage', error)
      // }
    }
  }))

export type EventAnalyticsStoreType = Instance<typeof EventAnalyticsStore>
